import { render, staticRenderFns } from "./MultipleTable.vue?vue&type=template&id=94465bb2"
import script from "./MultipleTable.vue?vue&type=script&lang=js"
export * from "./MultipleTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports